import PageHeader from "@/components/PageHeader";

const sections = [
  {
    h: "Information We Collect",
    p: [
      "When you contact us through this website, we may collect your name, email address, phone number (if provided), subject, and the message content you submit.",
      "We collect only information you voluntarily provide. We do not sell or rent your personal information to third parties.",
    ],
  },
  {
    h: "How We Use Information",
    p: [
      "Information submitted through our contact form is used solely to respond to your inquiry and provide customer support.",
      "We may retain submissions for record-keeping and to improve our service quality.",
    ],
  },
  {
    h: "Cookies",
    p: [
      "This website may use minimal cookies necessary for basic site functionality. We do not use cookies for advertising or third-party tracking.",
    ],
  },
  {
    h: "Data Security",
    p: [
      "We take reasonable steps to protect information submitted through our website. Submissions are stored in a secured database and access is limited to authorized personnel.",
    ],
  },
  {
    h: "Third-Party Services",
    p: [
      "Our website may include embedded content from third-party services such as map providers. These services may have their own privacy policies governing their use of information.",
    ],
  },
  {
    h: "Your Rights",
    p: [
      "You may request that we delete personal information you have submitted through our contact form. To make such a request, please email cnltech@proton.me.",
    ],
  },
  {
    h: "Contact",
    p: [
      "If you have questions about this privacy policy, please contact us at cnltech@proton.me or call +1 (951) 479-2470.",
    ],
  },
];

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <PageHeader
        eyebrow="Privacy"
        breadcrumb="Privacy Policy"
        title="Privacy Policy"
        subtitle="This page describes what information we collect when you use this website and how we use it."
      />

      <section className="bg-white">
        <div className="cnl-container py-20 lg:py-24 max-w-3xl">
          <div className="space-y-10 text-[15px] leading-relaxed text-gray-700">
            {sections.map((s) => (
              <article key={s.h}>
                <h2 className="text-[22px] font-bold tracking-tight text-[#0B192C]">
                  {s.h}
                </h2>
                <div className="mt-4 space-y-4">
                  {s.p.map((para, j) => (
                    <p key={j}>{para}</p>
                  ))}
                </div>
              </article>
            ))}
            <p className="text-[12.5px] text-gray-500 pt-4 border-t border-gray-200">
              Last updated:{" "}
              {new Date().toLocaleDateString("en-US", { month: "long", year: "numeric" })}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
